<template>
  <v-badge class="ml-1 mr-8" color="blue" content="PRO"/>
</template>

<script>
export default {
  name: "Pro"
}
</script>

<style scoped>
/*>>>.v-badge__badge {*/
/*  color: #0f265c;*/
/*}*/
</style>